import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import ContentPreview from '../ContentPreview/index.js';
import PositionedOverlay from '../PositionedOverlay/index.js';
function Tip(_ref) {
  let {
    title,
    body,
    image,
    borderColor,
    backgroundColor,
    className,
    cta,
    ...rest
  } = _ref;
  // deprecate `blue` to follow design system
  if (borderColor === 'blue') {
    borderColor = 'brand-tertiary';
    // eslint-disable-next-line no-console
    console.warn('borderColor blue is deprecated in Tip. Please use brand-tertiary.');
  }
  return /*#__PURE__*/_jsx(PositionedOverlay, {
    shrinkwrap: false
  }, void 0, /*#__PURE__*/React.createElement(PositionedOverlay.Base, Object.assign({
    "data-cmp": "tip",
    className: clsx(className, 'display-flex justify-content-center align-items-center padding-horizontal-2 padding-top-4', {
      [`border-${borderColor} rounded`]: borderColor,
      [`bg-${backgroundColor}`]: backgroundColor,
      'padding-bottom-5': cta,
      'padding-bottom-4': !cta
    }),
    key: "positioned-overlay-base"
  }, rest), /*#__PURE__*/_jsx(ContentPreview, {
    headline: title,
    summary: body,
    orientation: "landscape",
    image: image
  })), /*#__PURE__*/_jsx(PositionedOverlay.Anchor, {
    position: "bottomCenter",
    offsetBottom: 50
  }, void 0, cta));
}
export default /*#__PURE__*/memo(Tip);